import { FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from '@kanda-libs/ks-design-library';

import PageTitle from 'components/shared/PageTitle';

import SearchForm from './SearchForm';
import SearchResults from './SearchResults';

const HomePage: FunctionComponent = () => {
  return (
    <DesktopLayoutDefault>
      <div className="flex flex-col w-full flex-1 p-6 ">
        <PageTitle>Search</PageTitle>
        <SearchForm />
        <SearchResults />
      </div>
    </DesktopLayoutDefault>
  );
};

export default HomePage;
